import { getDocumentPageUrl } from './url-helpers';
import { openPopup } from './utils';
export function sharePublicationOnLinkedIn(config, publication, pageNumber) {
    shareLinkOnLinkedIn({
        url: getDocumentPageUrl({
            mainHost: config.hosts.main,
            documentName: publication.name,
            username: publication.username,
            pageNumber,
        }),
    });
}
export function shareLinkOnLinkedIn(link) {
    openPopup({
        url: 'https://www.linkedin.com/sharing/share-offsite',
        params: {
            url: link.url,
        },
    });
}
//# sourceMappingURL=linkedin.js.map